import type { WhyInvestItem } from "@/data/fund-detail-types";
import { cn } from "@/lib/utils";

export function FundWhyInvest({ items }: { items: WhyInvestItem[] }) {
  return (
    <div>
      <div className="font-[family-name:var(--font-instrument)] text-[12px] leading-[1.5] tracking-[0.15em] text-[var(--etf-orange)] uppercase mb-2.5 pl-4">
        Why Invest?
      </div>
      <div className="flex flex-col">
        {items.map((item, i) => (
          <div
            key={item.title}
            className={cn(
              "border-l-2 border-[var(--etf-orange)] px-4 py-1.5 flex items-start gap-3",
              i < items.length - 1 && "border-b border-b-white/[0.04]",
            )}
          >
            <span className="font-[family-name:var(--font-instrument)] text-[12px] leading-[1.5] text-[var(--etf-orange)] opacity-50 pt-0.5 shrink-0">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div>
              <div className="text-[12px] leading-[1.5] font-semibold text-[var(--etf-white)] mb-[3px] tracking-[0.02em]">
                {item.title}
              </div>
              <div className="text-[11px] italic text-[var(--etf-white3)] leading-normal font-light">
                {item.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
